"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./send"), exports);
(0, tslib_1.__exportStar)(require("./verificationDynamicCodeForResetTradePwd"), exports);
(0, tslib_1.__exportStar)(require("./getDynamicCodeResetTradePwd"), exports);
(0, tslib_1.__exportStar)(require("./getDynamicCodeResetLoginPwd"), exports);
(0, tslib_1.__exportStar)(require("./verificationDynamicCodeForResetLoginPwd"), exports);
(0, tslib_1.__exportStar)(require("./getPhoneDynamicCodeForAppRegister"), exports);
(0, tslib_1.__exportStar)(require("./getPhoneDynamicCodeForAppLogin"), exports);
(0, tslib_1.__exportStar)(require("./phoneDynamicLogin"), exports);
(0, tslib_1.__exportStar)(require("./phoneDynamicCodeCheck"), exports);
//# sourceMappingURL=index.js.map